const window = require('window');
const Backbone = require('backbone');
const format = require('format');
var SavingsView = Backbone.View.extend({
	el: '.js-product-savings',

	initialize: function() {
		var self = this;

		if (self.$('.js-savings-details').length) {
			import('app/views/store/pages/products/savings_details').then((SavingsDetails) => {
				self.childViews.savingsDetails = new SavingsDetails();
			});
		}
		this.listenTo(Backbone, 'finish:clicked', this.render);
		this.listenTo(Backbone, 'finish:hover', this.render);
	},
	decorateFinish: function(finish) {
		return Object.assign({}, finish, {
			BCOM: {
				theme: {
					isBuild: window.BCOM.theme.isBuild
				}
			},
			hasAddToCartMapBuster: finish.hasAddToCartMapBuster ? finish.hasAddToCartMapBuster : undefined,
			savingsFromConsumerPrice: finish.savingsFromConsumerPrice ? finish.savingsFromConsumerPrice : undefined,
			savingsText: finish.savingsDetails ? `${finish.savingsDetails.percentage}%` : format.currency(finish.savings)
		});
	},
	render: function(data) {
		if (window.BCOM.theme.isBuild || window.BCOM.theme.isLivingDirect) {
			if (data.isDefault) {
				this.$('.js-savings').html(data.savings);
			} else if (data.savingsDetails) {
				this.$('.js-savings-section, .js-separator').toggleClass('hidden', !data.savingsDetails.total);
				this.$('.js-savings').html(`${data.savingsDetails.percentage}%`);
			}
		}
	}
});

module.exports = SavingsView;
